<template>
  <provider-form
    :provider-id="providerId"
    :details="details"
    @submit="updateProvider"
    @close="$emit('close')"
  />
</template>

<script>
import ProviderForm from '../Form.vue'

export default {
  name: 'EditProvider',
  components: { ProviderForm },
}
</script>

<script>
import ProviderForm from '../Form.vue'
import redirectError from '@/services/redirectError'

export default {
  name: 'CreateProvider',
  components: { ProviderForm },
  props: {
    details: {
      type: Boolean,
      default: true,
    },
    providerId: {
      type: Number,
      default: null,
    },
  },
  methods: {
    updateProvider(provider) {
      const query = {
        provider: {
          name: provider.name,
          webhookUrl: provider.webhookUrl,
          type: provider.type,
        },
        id: this.providerId,
      }
      this.$store
        .dispatch('providers/updateProvider', query)
        .then(() => {
          this.successToast('Provider was updated!')
          this.$emit('onRefresh')
        })
        .catch(error => {
          redirectError(error)
          this.errorToast(
            error.response?.data?.errors[0] ||
              'Something went wrong while updating provider!',
          )
        })
    },
  },
}
</script>
